import AuthorizedRoute from 'Components/AuthorizedRoute';
import { SITE_PAGES } from 'Config';
import withRouter from 'Lib/hoc/withRouter';
import Resources from 'Pages/Resources';
import { Navigate, Route, Routes } from 'react-router';
import ManageServiceContractsView from './ManageServiceContractsView';
import ServiceContractDetailsPage from './ServiceContractDetailsPage';

let ServiceContractDetailWithRouter = withRouter(ServiceContractDetailsPage);

const ServiceContracts = () => {
  return (
    <Routes>
      <Route
        index
        element={<Navigate to={SITE_PAGES.ALL_SERVICE_CONTRACTS.to} replace />}
      />
      <Route
        path='contracts'
        element={
          <AuthorizedRoute
            requiredAuth={SITE_PAGES.ALL_SERVICE_CONTRACTS.requiredAuth}>
            <ManageServiceContractsView />
          </AuthorizedRoute>
        }
      />
      <Route
        path='contracts/:id'
        element={
          <AuthorizedRoute
            requiredAuth={SITE_PAGES.SERVICE_CONTRACT_LANDING.requiredAuth}>
            <ServiceContractDetailWithRouter />
          </AuthorizedRoute>
        }
      />

      <Route
        path='resources/*'
        element={
          <AuthorizedRoute requiredAuth={SITE_PAGES.ALL_RESOURCES.requiredAuth}>
            <Resources />
          </AuthorizedRoute>
        }
      />
    </Routes>
  );
};

let Page = withRouter(ServiceContracts);
export default Page;
